import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { BaseBean, RestReportBean } from "../ds/client_ds.js";
import {
  AvailableToSaleInfoBean,
  CustomerSalesOnOrderSearchCriteria,
  FabricStyleCustomerSalesSummaryCriteriaBean,
  FabricStyleOnHandDetailBean,
  FabricStyleSalesPersonSalesSummaryCriteriaBean,
  FabricStyleSearchCriteria,
  FabricStyleStatisticsInquiryCriteriaBean,
  FabricStyleStatisticsInquirySummaryDetailBean,
  FabricStyleStatisticsSummaryDetailPrintRequest,
  RestCustomerSalesOnOrderListRequest,
  RestFabricStyleListBeanRequest,
  RestFabricStyleStatisticsInquiryListRequest,
  RestPageListBean,
  RestReadRequest,
  RestSkuBatchInventoryListRequest,
  RestVendorPurchaseOnOrderListRequest,
  SKUBatchInventorySearchCriteria,
  VendorPurchaseOnOrderSearchCriteria,
} from "../ds/ds.js";
import { ConfigManager } from "../config/ConfigManager.js";
import { DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  CollapseComponent,
  InputTextbox,
  MultiViewPopup,
  NumberFormatInputbox,
  ProgressBar,
  ShowError,
} from "../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
  toDownloadReportAddress,
} from "../gui_components/Util.js";
import { FabricStyleLookupHandler } from "../lookup/FabricStyleLookupHandler.js";
import { GenericAttributeLookupHandler } from "../lookup/GenericAttributeLookupHandler.js";
import { BaseInquiryToolBar } from "../modules/BaseModule.js";
import {
  PopupCreditMemoModule,
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupSalesModule,
  PopupVendorModule,
} from "../modules/ModuleUtil.js";
import { CreditMemoService } from "../services/CreditMemoService.js";
import { CustomerService } from "../services/CustomerService.js";
import { FabricStyleService } from "../services/FabricStyleService.js";
import { InventoryService } from "../services/InventoryService.js";
import { PurchaseOrderReceiptService } from "../services/PurchaseOrderReceiptService.js";
import { ReportService } from "../services/ReportService.js";
import { VendorService } from "../services/VendorService.js";
class FabricStatistics extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      pageTitle: "Fabric Statistics Inquiry",
      isShowExecuteButton: true,
      isShowClearCriteriaButton: true,
      isShowClearErrorButton: false,
      isShowResetButton: false,
      showModuleList: [],
      isShowExitButton: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      error_list: [],
      inquiryDataList: [],
      criteria: new FabricStyleStatisticsInquiryCriteriaBean(),
      fabricData: new FabricStyleStatisticsInquirySummaryDetailBean(),
      pageList: new RestPageListBean(),
      isInquiryDatasFound: false,
      isShowAlert: false,
      alertMsg: "",
      success_list: [],
      isShowFabricStyleModule: false,
      isShowCreditMemoModule: false,
      isShowCustomerModule: false,
      isShowSalesModule: false,
      isShowPurchaseReceiptModule: false,
      isShowPurchaseOrderModule: false,
      isShowInvoiceModule: false,
      isShowVendorModule: false,
      moduleForPopup: [],
      onHandQtyList: new Array(),
      customerSalesDetailList: new Array(),
      salesPersonSalesDetailList: new Array(),
      availableListToSaleList: new Array(),
      isDisableFields: false,
      alertMessage: "",
      isShowAlertLvl3: false,
      order: "asc",
      sortField: "",
      patternTypes: [],
      productTypes: [],
      makeTypes: [],
      isCollapsible_open: true,
      isShowLookUp: true,
      onLocationList: new Array(),
      isShowOnHandQtyPopup: false,
      isShowVendorQtyPopup: false,
      isShowCustomerQtyPopup: false,
      isShowLastReceiptDetailsPopup: false,
      isShowLastSalesDetailPopup: false,
      isShowLastReturnDetailPopup: false,
      customerQtyDataList: new Array(),
      availableToSaleData: new AvailableToSaleInfoBean(),
      onHandQtyData: new FabricStyleOnHandDetailBean(),
      lastReceiptList: [],
      lastSalesList: [],
      lastReturnList: [],
      vendorQtyDataList: [],
      isShowCustomerLastSalesDetailsPopup: false,
      isShowSalesPersonLastSalesDetailsPopup: false,
      customerLastSalesList: [],
      salespersonLastSalesList: [],
      isShowTotalOnOrder: false,
      is3PL: false,
    };
    this.currency = "USD";
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };
    // let attribute_cache = JSON.parse(localStorage.getItem("attributeCache"));
    let patternTypes = attribute_cache.patternTypes;
    if (patternTypes != null || patternTypes != undefined) {
      patternTypes.map((attr) => {
        this.state.patternTypes.push(attr);
      });
    }
    let productTypes = attribute_cache.productTypes;
    if (productTypes != null || productTypes != undefined) {
      productTypes.map((attr) => {
        this.state.productTypes.push(attr);
      });
    }
    let makeTypes = attribute_cache.makeTypes;
    if (makeTypes != null || makeTypes != undefined) {
      makeTypes.map((attr) => {
        this.state.makeTypes.push(attr);
      });
    }
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      this.state.is3PL = true;
      this.setState({
        is3PL: true,
      });
    }
    this.initLookupHandlers();
  }
  initLookupHandlers = () => {
    let patternTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.patternTypes,
      "Style"
    );
    this.setState({ patternTypeLookupHandler: patternTypeLookupHandler });
    let productTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.productTypes,
      "Type"
    );
    this.setState({ productTypeLookupHandler: productTypeLookupHandler });
    let makeTypeLookupHandler = new GenericAttributeLookupHandler(
      this.state.makeTypes,
      "Content"
    );
    this.setState({ makeTypeLookupHandler: makeTypeLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      this.state.is3PL ? "Item" : "Fabric Style"
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });
  };
  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  showInfoMessage = (response) => {
    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  onPatternTypeCodeChange = (e) => {
    let productTypeCode = e.target.value;
    this.state.showAutoCompletePatternTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
    if (isEmpty(productTypeCode)) {
      this.state.showAutoCompletePatternTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
      let criteria = this.state.criteria;
      criteria.productTypeCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: criteria,
        patternTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && productTypeCode !== "") {
      this.readPatternTypeBySearchString(productTypeCode);
    }
    if (e.target.name == "productTypeCode") {
      temp_criteria["productTypeCode"] = e.target.value;
      let productType_List = this.state.productTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_criteria["productTypeCode"] = pdtType.code;
          temp_criteria["productTypeName"] = pdtType.description;
          this.state.showAutoCompletePatternTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompletePatternTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readPatternTypeBySearchString(searchString) {
    let patternTypeData = this.state.productTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((patternTypeDatas) => {
        let simpleItemBean = {
          code: patternTypeDatas.code,
          description: patternTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletePatternTypeLists) =>
        simpleAutoCompletePatternTypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      patternTypePageListForAutoCompleteList: filteredSuggestions,
    });
  }
  patternTypeEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let productTypeCode = e.target.value;
    temp_criteria["productTypeCode"] = e.target.value;
    let productType_List = this.state.productTypes;
    let productTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        productTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(productTypeCodeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.productTypeCode = productTypeCodeBean.code;
      temp_criteria.productTypeName = productTypeCodeBean.description;
      this.setState({
        criteria: temp_criteria,
        patternTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onTypeCodeChange = (e) => {
    let patternTypeCode = e.target.value;
    this.state.showAutoCompleteTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteTypeList;
    if (isEmpty(patternTypeCode)) {
      this.state.showAutoCompleteTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteTypeList;
      let soLine = this.state.criteria;
      soLine.patternTypeCode = "";
      soLine.patternTypeName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: soLine,
        typePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && patternTypeCode !== "") {
      this.readTypeBySearchString(patternTypeCode);
    }
    if (e.target.name == "patternTypeCode") {
      temp_criteria["patternTypeCode"] = e.target.value;
      let productType_List = this.state.patternTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_criteria["patternTypeCode"] = pdtType.code;
          temp_criteria["patternTypeName"] = pdtType.description;
          this.state.showAutoCompleteTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readTypeBySearchString(searchString) {
    let patternTypeData = this.state.patternTypes;
    let simpleAutoCompleteList = new Array();
    if (patternTypeData.length > 0 && patternTypeData != null) {
      patternTypeData.map((typeDatas) => {
        let simpleItemBean = {
          code: typeDatas.code,
          description: typeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletetypeLists) =>
        simpleAutoCompletetypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ typePageListForAutoCompleteList: filteredSuggestions });
  }
  typeEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let patternTypeCode = e.target.value;
    temp_criteria["patternTypeCode"] = e.target.value;
    let productType_List = this.state.patternTypes;
    let patternTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        patternTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(patternTypeCodeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.patternTypeCode = patternTypeCodeBean.code;
      temp_criteria.patternTypeName = patternTypeCodeBean.description;
      this.setState({
        criteria: temp_criteria,
        typePageListForAutoCompleteList: new Array(),
      });
    }
  };
  onMakeTypeCodeChange = (e) => {
    let makeTypeCode = e.target.value;
    this.state.showAutoCompleteMakeTypeList = true;
    let temp_criteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
    if (isEmpty(makeTypeCode)) {
      this.state.showAutoCompleteMakeTypeList = false;
      let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
      let soLine = this.state.criteria;
      soLine.makeTypeCode = "";
      soLine.makeTypeName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        criteria: soLine,
        makeTypePageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && makeTypeCode !== "") {
      this.readMakeTypeBySearchString(makeTypeCode);
    }
    if (e.target.name == "makeTypeCode") {
      temp_criteria["makeTypeCode"] = e.target.value;
      let productType_List = this.state.makeTypes;
      productType_List.map((pdtType) => {
        if (pdtType.code == e.target.value) {
          temp_criteria["makeTypeCode"] = pdtType.code;
          temp_criteria["makeTypeName"] = pdtType.description;
          this.state.showAutoCompleteMakeTypeList = false;
          let showAutoCompleteList = this.state.showAutoCompleteMakeTypeList;
          this.setState({ showAutoCompleteList: showAutoCompleteList });
        }
      });
    }
    this.setState({ criteria: temp_criteria });
  };
  readMakeTypeBySearchString(searchString) {
    let makeTypeData = this.state.makeTypes;
    let simpleAutoCompleteList = new Array();
    if (makeTypeData.length > 0 && makeTypeData != null) {
      makeTypeData.map((makeTypeDatas) => {
        let simpleItemBean = {
          code: makeTypeDatas.code,
          description: makeTypeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompletetypeLists) =>
        simpleAutoCompletetypeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({ makeTypePageListForAutoCompleteList: filteredSuggestions });
  }
  makeTypeEnterKeyEvent = (e) => {
    let temp_criteria = this.state.criteria;
    let makeTypeCode = e.target.value;
    temp_criteria["makeTypeCode"] = e.target.value;
    let productType_List = this.state.makeTypes;
    let makeTypeCodeBean = null;
    productType_List.map((pdtType) => {
      if (pdtType.code == e.target.value) {
        makeTypeCodeBean = pdtType;
      }
    });
    if (!isEmpty(makeTypeCodeBean)) {
      let temp_criteria = this.state.criteria;
      temp_criteria.makeTypeCode = makeTypeCodeBean.code;
      temp_criteria.makeTypeName = makeTypeCodeBean.description;
      this.setState({
        criteria: temp_criteria,
        makeTypePageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompletePatternTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompletePatternTypeList: showAutoCompleteList });
  };
  displayAutoCompleteTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteTypeList: showAutoCompleteList });
  };
  displayAutoCompleteMakeTypeList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteMakeTypeList: showAutoCompleteList });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.showAutoCompleteFabricList = true;
    let tempCriteria = this.state.criteria;
    let showAutoCompleteList = this.state.showAutoCompleteFabricList;
    if (isEmptyString(fabricStyleCode)) {
      this.state.showAutoCompleteFabricList = false;
      let showAutoCompleteList = this.state.showAutoCompleteFabricList;
      let criteria = this.state.criteria;
      criteria.fabricStyleCode = " ";
      criteria.fabricStyleName = " ";
      criteria.fabricStyleColorCode = " ";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricList: showAutoCompleteList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
        fabricPageListForAutoCompleteList: suggestion,
        isShowColorLookup: false,
        colorList: [],
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.loadFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ criteria: tempCriteria });
  };
  loadFabricStyleDetailResponse = (response) => {
    let criteria = this.state.criteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        criteria.fabricStyleCode = fabricStyle.code;
        criteria.fabricStyleName = fabricStyle.description;
        let colors = fabricStyle.colors;
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color"
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            criteria: criteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            isDisable: false,
            isShowLookUp: true,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  loadFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.loadFabricStyleDetailResponse,
      this.errorCallBack
    );
  };
  loadFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.loadFabricCodeResponse,
      this.errorCallBack
    );
  }
  loadFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    let fabricStyleCode = e.target.value;
    this.loadFabricStyleDetail(fabricStyleCode);

    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "Item read" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricList: showAutoCompleteList });
  };
  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;

    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.criteria;
      criteria.fabricStyleColorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        criteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "fabricStyleColorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.loadFabricColourBySearchString(e.target.value);
    }
  };
  loadFabricColourBySearchString(searchString) {
    let fabricStyle = this.state.fabricStyleData;
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.criteria;
    criteria.fabricStyleColorCode = colorCode;
    this.setState({ criteria: criteria });
  };
  showHideSecondHeader = (e) => {
    if (e.detail === 1) {
      let isCollapsible_open = !this.state.isCollapsible_open;
      this.setState({ isCollapsible_open: isCollapsible_open });
    }
  };
  onChange = (e) => {
    let criteria = this.state.criteria;
    criteria[e.target.name] = e.target.value;
    this.setState({ criteria: criteria });
  };
  searchFabric = (e) => {
    if (e.detail === 1) this.loadPage(1);
  };
  resetFabric = (e) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      this.setState({
        criteria: criteria,
        fabricData: new FabricStyleStatisticsInquirySummaryDetailBean(),
        availableToSaleData: new AvailableToSaleInfoBean(),
        onHandQtyData: new FabricStyleOnHandDetailBean(),
        onHandQtyList: new Array(),
        availableListToSaleList: new Array(),
        customerSalesDetailList: new Array(),
        salesPersonSalesDetailList: new Array(),
        onLocationList: new Array(),
        customerLastSalesList: new Array(),
        lastReceiptDetails: new Array(),
        lastSalesDetails: new Array(),
        lastReturnDetails: new Array(),
        vendorQtyDataList: new Array(),
        customerQtyDataList: new Array(),
        salespersonLastSalesList: new Array(),
        isShowTotalOnOrder: false,
      });
      this.loadPage(1);
    }
  };
  execute = () => {
    this.hideAlertCallBack();
    this.loadPage(1);
  };
  validate = (data) => {
    let isValid = false;
    let err_list = [];
    let errorMessage = "";

    if (isEmptyString(data.fabricStyleCode)) {
      let errMsg = this.state.is3PL
        ? "Enter ItemCode is Required"
        : "Enter Fabric Style is Required";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    }
    if (err_list.length > 0) {
      isValid = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
        isLoading: false,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      isValid = true;
      this.setState({ isShowAlert: false });
    }
    return isValid;
  };
  loadPage = () => {
    let criteria = this.state.criteria;
    criteria.companyCode = this.companyCode;
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let isValid = false;
    isValid = this.validate(criteria);
    if (isValid) {
      this.loadFabricStyleStatisticsInquiryList(criteria);
    }
  };
  loadFabricStyleStatisticsInquiryList = (listRequest) => {
    // if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
    ReportService.inquireFabricStyleStatisticsSummaryData(
      listRequest,
      this.fabricStyleStatisticsPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  fabricStyleStatisticsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.inquiryResult != null) {
      let summaryResult = [];
      if (response.data.inquiryResult.summaryDatas != null) {
        if (!isEmptyArray(response.data.inquiryResult.summaryDatas)) {
          summaryResult = response.data.inquiryResult.summaryDatas;
        }
      }
      this.setState({
        isInquiryDatasFound: true,
        isShowResetButton: true,
        isShowClearCriteriaButton: false,
        inquiryDataList: summaryResult,
        isCollapsible_open: false,
      });
      this.disable();
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  clearError = () => {};
  statusConventor = (data, type) => {
    let status = "";
    if (data == "A") {
      status = "Approved";
    } else if (data == "F") {
      status = "Paid";
    } else if (data == "X") {
      status = "Cancelled";
    } else if (data == "U") {
      status = "UnApproved";
    } else if (data == "P") {
      status = "PartiallyPaid";
    }

    if (type == 1) {
      status = status + " :: Invoice";
    } else if (type == 2) {
      status = status + " :: CreditMemo";
    }
    return status;
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  hideAlertCallBackLvl3 = (msgType, isDisplayed) => {
    this.setState({ isShowAlertLvl3: isDisplayed, error_list: [] });
  };
  viewFabricDetails = (e, code, row) => {
    if (e.detail === 1) {
      let readrestInput = new FabricStyleStatisticsInquiryCriteriaBean();
      readrestInput.companyCode = this.companyCode;
      readrestInput.fabricStyleCode = code;
      readrestInput.fabricStyleColorCode = row.fabricStyleColorCode;
      readrestInput.fabricStyleName = row.fabricStyleName;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Fetching Details...",
      });
      // if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
      ReportService.inquireFabricStyleStatisticsSummaryDetailData(
        readrestInput,
        this.readFabricDetailsResponse,
        this.errorCallBack
      );
      // } else {
      //   this.inValidAccess(1);
      // }
    }
  };
  readFabricDetailsResponse = (response) => {
    this.showErrorMessage(response.data);
    let fabricData = this.state.fabricData;
    if (response.data != null && response.data.summaryDetailBean != null) {
      fabricData = response.data.summaryDetailBean;
      let onHandQtyList = [];
      let customerSalesDetailList = [];
      let availableListToSaleList = [];
      let salesPersonSalesDetailList = [];
      if (response.data.summaryDetailBean.onHandDetails != null) {
        onHandQtyList = response.data.summaryDetailBean.onHandDetails;
      }
      if (
        response.data.summaryDetailBean.availableToSalesDetailBean.saleInfos !=
        null
      ) {
        availableListToSaleList =
          response.data.summaryDetailBean.availableToSalesDetailBean.saleInfos;
      }
      if (response.data.summaryDetailBean.customerSalesSummaryData != null) {
        customerSalesDetailList =
          response.data.summaryDetailBean.customerSalesSummaryData;
      }

      if (response.data.summaryDetailBean.salesPersonSalesSummaryData != null) {
        salesPersonSalesDetailList =
          response.data.summaryDetailBean.salesPersonSalesSummaryData;
      }
      this.setState({
        fabricData: fabricData,
        onHandQtyList: onHandQtyList,
        availableListToSaleList: availableListToSaleList,
        salesPersonSalesDetailList: salesPersonSalesDetailList,
        customerSalesDetailList: customerSalesDetailList,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    } else {
      this.setState({
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
  };
  onLocationClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let fabricData = this.state.fabricData;
      let onHandQtyData = this.state.onHandQtyData;
      onHandQtyData.companyCode = this.companyCode;
      onHandQtyData.locationCode = rowData.locationCode;
      onHandQtyData.onHandQuatity = rowData.onHandQuatity;
      onHandQtyData.noOfRolls = rowData.noOfRolls;
      this.setState({ onHandQtyData: onHandQtyData });
      let qtyCriteria = new SKUBatchInventorySearchCriteria();
      qtyCriteria.companyCode = this.companyCode;
      qtyCriteria.fabricStyleCode = fabricData.fabricStyleCode;
      qtyCriteria.colorCode = fabricData.colorCode;
      qtyCriteria.locationCode = val;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 100;
      pageInput.currentPage = 1;
      let listRequest = new RestSkuBatchInventoryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = qtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "fetching Location details...",
      });
      this.loadOnHandQtyListPage(listRequest);
    }
  };
  loadOnHandQtyListPage = (listRequest) => {
    // if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
    InventoryService.getSkuBatchInventoryPageList(
      listRequest,
      this.loadOnHandQtyPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadOnHandQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.skuBatchInventoryPageList != null
    ) {
      let onLocationList = [];
      const locationList =
        response.data.skuBatchInventoryPageList.skuBatchInventories;
      if (onLocationList != null) {
        locationList.map((data) => {
          if (data.onHandQuantity != 0) {
            onLocationList.push(data);
          }
        });
        this.setState({
          onLocationList: onLocationList,
          isShowOnHandQtyPopup: true,
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  totalVendorOnOrderQtyClick = (e, val) => {
    if (e.detail === 1) {
      let fabricData = this.state.fabricData;
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = fabricData.fabricStyleCode;
      vendorQtyCriteria.colorCode = fabricData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowTotalOnOrder: true,
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading vendorOnOrder...",
      });
      if (val > 0) {
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  vendorOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let availableToSaleData = new AvailableToSaleInfoBean();
      availableToSaleData.companyCode = this.companyCode;
      availableToSaleData.purchaseOnOrderQuantity = val;

      this.setState({
        availableToSaleData: availableToSaleData,
        isShowTotalOnOrder: false,
      });
      let fabricData = this.state.fabricData;
      let vendorQtyCriteria = new VendorPurchaseOnOrderSearchCriteria();
      vendorQtyCriteria.companyCode = this.companyCode;
      vendorQtyCriteria.fabricStyleCode = fabricData.fabricStyleCode;
      vendorQtyCriteria.colorCode = fabricData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestVendorPurchaseOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = vendorQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading vendorOnOrder...",
      });
      if (val > 0) {
        this.loadVendorOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadVendorOnOrderQtyListPage = (listRequest) => {
    //  if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
    VendorService.getVendorPurchaseOnOrderDetailsForFabricStyleStatistics(
      listRequest,
      this.loadPOFabricStatisticsResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadPOFabricStatisticsResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.orderDetailsResult != null) {
      let vendorQtyDataList = new Array();
      let sourceSalesOrderDataList = new Array();
      if (response.data.orderDetailsResult.onOrderInfoDetails != null) {
        vendorQtyDataList = response.data.orderDetailsResult.onOrderInfoDetails;
      }
      if (response.data.orderDetailsResult.sourceOrderDetailLines != null) {
        sourceSalesOrderDataList =
          response.data.orderDetailsResult.sourceOrderDetailLines;
      }
      this.setState({
        vendorQtyDataList: vendorQtyDataList,
        sourceSalesOrderDataList: sourceSalesOrderDataList,
        isShowVendorQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  lastReturnDetails = (e, val, month) => {
    if (e.detail === 1) {
      let fabricData = this.state.fabricData;
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricData.fabricStyleCode;
      criteria.fabricStyleColorCode = fabricData.colorCode;
      if (val > 0) {
        if (month === 3) {
          CreditMemoService.getCreditMemoListForLast3MonthsForFabricStyleStatistics(
            criteria,
            this.loadMonthsReturnPageResponse,
            this.errorCallBack
          );
        } else if (month === 6) {
          CreditMemoService.getCreditMemoListForLast6MonthsForFabricStyleStatistics(
            criteria,
            this.loadMonthsReturnPageResponse,
            this.errorCallBack
          );
        } else if (month === 12) {
          CreditMemoService.getCreditMemoListForLast12MonthsForFabricStyleStatistics(
            criteria,
            this.loadMonthsReturnPageResponse,
            this.errorCallBack
          );
        } else if (month === 18) {
          CreditMemoService.getCreditMemoListForLast18MonthsForFabricStyleStatistics(
            criteria,
            this.loadMonthsSalesPageResponse,
            this.errorCallBack
          );
        } else if (month === 24) {
          CreditMemoService.getCreditMemoListForLast24MonthsForFabricStyleStatistics(
            criteria,
            this.loadMonthsReturnPageResponse,
            this.errorCallBack
          );
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadMonthsReturnPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let lastReturnList = [];
      if (!isEmptyArray(response.data.result.creditMemos)) {
        lastReturnList = response.data.result.creditMemos;
        this.setState({
          lastReturnList: lastReturnList,
          isShowLastReturnDetailPopup: true,
        });
      }
    }
  };
  lastSalesDetails = (e, val, month) => {
    if (e.detail === 1) {
      let fabricData = this.state.fabricData;
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricData.fabricStyleCode;
      criteria.fabricStyleColorCode = fabricData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestFabricStyleStatisticsInquiryListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = criteria;
      if (val > 0) {
        if (month === 3) {
          ReportService.getInvoiceListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadMonthsSalesPageResponse,
            this.errorCallBack
          );
        } else if (month === 6) {
          ReportService.getInvoiceListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadMonthsSalesPageResponse,
            this.errorCallBack
          );
        } else if (month === 12) {
          ReportService.getInvoiceListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadMonthsSalesPageResponse,
            this.errorCallBack
          );
        } else if (month === 18) {
          ReportService.getInvoiceListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadMonthsSalesPageResponse,
            this.errorCallBack
          );
        } else if (month === 24) {
          ReportService.getInvoiceListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
            listRequest,
            this.loadMonthsSalesPageResponse,
            this.errorCallBack
          );
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadMonthsSalesPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let lastSalesList = [];
      if (!isEmptyArray(response.data.result.invoices)) {
        lastSalesList = response.data.result.invoices;
        this.setState({
          lastSalesList: lastSalesList,
          isShowLastSalesDetailPopup: true,
        });
      }
    }
  };
  lastReceiptDetails = (e, val, month) => {
    if (e.detail === 1) {
      let fabricData = this.state.fabricData;
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricData.fabricStyleCode;
      criteria.fabricStyleColorCode = fabricData.colorCode;
      if (val > 0) {
        if (month === 3) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast3MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 6) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast6MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 12) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast12MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 18) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast18MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        } else if (month === 24) {
          PurchaseOrderReceiptService.getPurchaseOrderReceiptListForLast24MonthsSalesInvoiceForFabricStyleStatistics(
            criteria,
            this.loadMonthsReceiptPageResponse,
            this.errorCallBack
          );
        }
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadMonthsReceiptPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let lastReceiptList = [];
      if (!isEmptyArray(response.data.result.purchaseReceipts)) {
        lastReceiptList = response.data.result.purchaseReceipts;
        this.setState({
          lastReceiptList: lastReceiptList,
          isShowLastReceiptDetailsPopup: true,
        });
      }
    }
  };
  totalCustomerOnOrderQtyClick = (e, val) => {
    if (e.detail === 1) {
      let fabricData = this.state.fabricData;

      let custQtyCriteria = new CustomerSalesOnOrderSearchCriteria();
      custQtyCriteria.companyCode = this.companyCode;
      custQtyCriteria.fabricStyleCode = fabricData.fabricStyleCode;
      custQtyCriteria.colorCode = fabricData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestCustomerSalesOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = custQtyCriteria;
      this.setState({
        isShowTotalOnOrder: true,
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Customer OnOrder detais...",
      });
      if (val > 0) {
        this.loadCustomerOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  customerOnOrderQtyClick = (e, val, rowData) => {
    if (e.detail === 1) {
      let availableToSaleData = new AvailableToSaleInfoBean();
      availableToSaleData.companyCode = this.companyCode;
      availableToSaleData.salesOnOrderQuantity = val;
      this.setState({
        availableToSaleData: availableToSaleData,
        isShowTotalOnOrder: false,
      });
      let fabricData = this.state.fabricData;
      let custQtyCriteria = new CustomerSalesOnOrderSearchCriteria();
      custQtyCriteria.companyCode = this.companyCode;
      custQtyCriteria.fabricStyleCode = fabricData.fabricStyleCode;
      custQtyCriteria.colorCode = fabricData.colorCode;
      let pageInput = new RestPageListBean();
      pageInput.pageSize = 20;
      pageInput.currentPage = 1;
      let listRequest = new RestCustomerSalesOnOrderListRequest();
      listRequest.pageInput = pageInput;
      listRequest.searchCriteria = custQtyCriteria;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Loading Customer OnOrder detais...",
      });
      if (val > 0) {
        this.loadCustomerOnOrderQtyListPage(listRequest);
      } else {
        this.setState({
          isShowProgressBarPopup: false,
          progressLoadingText: "",
        });
        let errMsg = "No data found";
        let errList = new Array();
        errList.push(errMsg);
        this.setState({ error_list: errList });
        this.setState({
          alertMessage: errList,
          alertType: "danger",
          isShowAlert: true,
        });
      }
    }
  };
  loadCustomerOnOrderQtyListPage = (listRequest) => {
    // if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
    CustomerService.getCustomerSalesOnOrderDetailsForFabricStyleStatistics(
      listRequest,
      this.loadCustomerOnOrderQtyPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadCustomerOnOrderQtyPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (
      response.data != null &&
      response.data.orderDetailsResult != null &&
      response.data.orderDetailsResult.onOrderInfoDetails != null
    ) {
      const customerQtyDataList =
        response.data.orderDetailsResult.onOrderInfoDetails;
      this.setState({
        customerQtyDataList: customerQtyDataList,
        isShowCustomerQtyPopup: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  viewSalesPersonLastSalesDetail = (e, val, rowData, month) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleSalesPersonSalesSummaryCriteriaBean();
      let tempCriteria = this.state.criteria;
      criteria.companyCode = this.companyCode;
      criteria.salesPersonCode = rowData.salesPersonCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = tempCriteria.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      if (month === 3) {
        criteria.startDate = rowData.last3MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last3MonthsPeriodSalesQuantity.endDate;
      } else if (month === 6) {
        criteria.startDate = rowData.last6MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last6MonthsPeriodSalesQuantity.endDate;
      } else if (month === 12) {
        criteria.startDate = rowData.last12MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last12MonthsPeriodSalesQuantity.endDate;
      } else if (month === 18) {
        criteria.startDate = rowData.last18MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last18MonthsPeriodSalesQuantity.endDate;
      }
      this.loadSalesPersonlastSalesListRequest(criteria);
    }
  };
  loadSalesPersonlastSalesListRequest = (listRequest) => {
    //if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
    ReportService.inquireFabricStyleSalesPersonSalesSummaryDetailData(
      listRequest,
      this.loadSalesPersonLastSalesPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadSalesPersonLastSalesPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let salespersonLastSalesList = [];
      if (!isEmptyArray(response.data.result.summaryDetailData)) {
        salespersonLastSalesList = response.data.result.summaryDetailData;
        this.setState({
          salespersonLastSalesList: salespersonLastSalesList,
          isShowSalesPersonLastSalesDetailsPopup: true,
        });
      }
    }
  };
  viewCustomerLastSalesDetail = (e, val, rowData, month) => {
    if (e.detail === 1) {
      let criteria = new FabricStyleCustomerSalesSummaryCriteriaBean();
      let tempCriteria = this.state.criteria;
      criteria.companyCode = this.companyCode;
      criteria.customerCode = rowData.customerCode;
      criteria.fabricStyleCode = rowData.fabricStyleCode;
      criteria.fabricStyleName = tempCriteria.fabricStyleName;
      criteria.fabricStyleColorCode = rowData.fabricStyleColorCode;
      if (month === 3) {
        criteria.startDate = rowData.last3MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last3MonthsPeriodSalesQuantity.endDate;
      } else if (month === 6) {
        criteria.startDate = rowData.last6MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last6MonthsPeriodSalesQuantity.endDate;
      } else if (month === 12) {
        criteria.startDate = rowData.last12MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last12MonthsPeriodSalesQuantity.endDate;
      } else if (month === 18) {
        criteria.startDate = rowData.last18MonthsPeriodSalesQuantity.startDate;
        criteria.endDate = rowData.last18MonthsPeriodSalesQuantity.endDate;
      }
      this.loadCustomerlastSalesListRequest(criteria);
    }
  };
  loadCustomerlastSalesListRequest = (listRequest) => {
    //  if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
    ReportService.inquireFabricStyleCustomerSalesSummaryDetailData(
      listRequest,
      this.loadCustomerLastSalesPageResponse,
      this.errorCallBack
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };

  loadCustomerLastSalesPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.result != null) {
      let lastSalesList = [];
      if (!isEmptyArray(response.data.result.summaryDetailData)) {
        lastSalesList = response.data.result.summaryDetailData;
        this.setState({
          customerLastSalesList: lastSalesList,
          isShowCustomerLastSalesDetailsPopup: true,
        });
      }
    }
  };

  generatePDF = (e) => {
    if (e.detail === 1) this.generateFabricStatisticsReport(1);
  };
  generateExcel = (e) => {
    if (e.detail === 1) this.generateFabricStatisticsReport(2);
  };
  generateFabricStatisticsReport = (reportType) => {
    let fabricStyleData = this.state.fabricData;
    let temp_criteria = this.state.criteria;
    if (!isEmptyArray(fabricStyleData)) {
      let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
      criteria.companyCode = this.companyCode;
      criteria.fabricStyleCode = fabricStyleData.fabricStyleCode;
      criteria.fabricStyleName = temp_criteria.fabricStyleName;
      criteria.fabricStyleColorCode = fabricStyleData.colorCode;
      let reportBean = new RestReportBean();
      reportBean.reportType = reportType;
      let listRequest = new FabricStyleStatisticsSummaryDetailPrintRequest();
      listRequest.criteria = criteria;
      listRequest.reportBean = reportBean;
      this.setState({
        isShowProgressBarPopup: true,
        progressLoadingText: "Generating Report...",
      });
      if (reportBean.reportType == 1) {
        // if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
        ReportService.generateFabricStyleStatisticsSummaryDetailPrintReport(
          listRequest,
          this.generateFabricStatisticsPageResponse,
          this.errorCallBack
        );
        // } else {
        //   this.inValidAccess(2);
        // }
      } else if (reportBean.reportType == 2) {
        //  if (SecurityAccessManager.FabricStatisticsInquiry_IsAccessible()) {
        ReportService.generateFabricStyleStatisticsSummaryDetailPrintReport(
          listRequest,
          this.generateFabricStatisticsPageExcelResponse,
          this.errorCallBack
        );
        // } else {
        //   this.inValidAccess(3);
        // }
      }
    } else {
      let errMsg = this.state.is3PL
        ? "Select Any Item SKU"
        : "Select Any FabricStyle SKU";
      let errList = [];
      errList.push(errMsg);
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlertLvl3: true,
      });
    }
  };
  generateFabricStatisticsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

    generateFabricStatisticsPageExcelResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
          let downloadAddress = toDownloadReportAddress(reportFilePath,true,true,this.report_url);
         window.open(downloadAddress, "_blank");
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowOnHandQtyPopup: isShowPopup,
      isShowVendorQtyPopup: isShowPopup,
      isShowCustomerQtyPopup: isShowPopup,
      isShowLastReceiptDetailsPopup: isShowPopup,
      isShowLastSalesDetailPopup: isShowPopup,
      isShowLastReturnDetailPopup: isShowPopup,
      isShowCustomerLastSalesDetailsPopup: isShowPopup,
      isShowSalesPersonLastSalesDetailsPopup: isShowPopup,
      isShowAlert: isShowPopup,
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewSalesModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowSalesModule: true,
          moduleForPopup: (
            <PopupSalesModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPoModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseOrderModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPurchaseReceiptModule = (e, code) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPurchaseReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCreditMemoModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCreditMemoModule: true,
          moduleForPopup: (
            <PopupCreditMemoModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowSalesModule: isOpen,
      isShowPurchaseReceiptModule: isOpen,
      isShowPurchaseOrderModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowFabricStyleModule: isOpen,
      isShowCreditMemoModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowVendorModule: isOpen,
      moduleForPopup: [],
    });
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };
  clearCriteria = () => {
    let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.currencyCode = this.currency;
    this.setState({
      criteria: criteria,
      isShowLookUp: true,
      isShowColorLookup: false,
      isCollapsible_open: true,
    });
  };
  resetInquiry = () => {
    let criteria = new FabricStyleStatisticsInquiryCriteriaBean();
    criteria.companyCode = this.companyCode;
    criteria.fabricStyleName = "";
    this.setState({
      criteria: criteria,
      isInquiryDatasFound: false,
      inquiryDataList: new Array(),
      isShowColorLookup: false,
      isShowPDFButton: false,
      isShowResetButton: false,
      isShowClearCriteriaButton: true,
      isDisableFields: false,
      isShowLookUp: true,
      isCollapsible_open: true,
      isShowTotalOnOrder: false,
      fabricData: new FabricStyleStatisticsInquirySummaryDetailBean(),
      availableToSaleData: new AvailableToSaleInfoBean(),
      onHandQtyData: new FabricStyleOnHandDetailBean(),
      onHandQtyList: new Array(),
      availableListToSaleList: new Array(),
      customerSalesDetailList: new Array(),
      salesPersonSalesDetailList: new Array(),
      onLocationList: new Array(),
      customerLastSalesList: new Array(),
      lastReceiptDetails: new Array(),
      lastSalesDetails: new Array(),
      lastReturnDetails: new Array(),
      vendorQtyDataList: new Array(),
      customerQtyDataList: new Array(),
      salespersonLastSalesList: new Array(),
    });
    this.hideAlertCallBack();
  };
  handleSortingCustomerQtyChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSortingCustomerQty(sortField, sortOrder);
  };
  handleSortingCustomerQty = (sortField, sortOrder) => {
    let list = this.state.customerQtyDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerQtyDataList: sorted });
    }
  };
  handleSortingOnHandQtyChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingOnHandQty(sortField, sortOrder);
    }
  };
  handleSortingOnHandQty = (sortField, sortOrder) => {
    let list = this.state.onHandQtyList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ onHandQtyList: sorted });
    }
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSorting(sortField, sortOrder);
    }
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inquiryDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inquiryDataList: sorted });
    }
  };
  handleSortingAvailableToSaleChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingAvailableToSale(sortField, sortOrder);
    }
  };
  handleSortingAvailableToSale = (sortField, sortOrder) => {
    let list = this.state.availableListToSaleList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ availableListToSaleList: sorted });
    }
  };
  handleSortingSalesPersonSalesDetailChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingSalesPersonSalesDetail(sortField, sortOrder);
    }
  };
  handleSortingSalesPersonSalesDetail = (sortField, sortOrder) => {
    let list = this.state.salesPersonSalesDetailList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ salesPersonSalesDetailList: sorted });
    }
  };
  handleSortingCustomerSalesDetailChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCustomerSalesDetail(sortField, sortOrder);
    }
  };
  handleSortingCustomerSalesDetail = (sortField, sortOrder) => {
    let list = this.state.customerSalesDetailList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerSalesDetailList: sorted });
    }
  };
  handleSortingOnLocationChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingOnLocation(sortField, sortOrder);
    }
  };
  handleSortingOnLocation = (sortField, sortOrder) => {
    let list = this.state.onLocationList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ onLocationList: sorted });
    }
  };
  handleSortingMonthToDateQtyChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingMonthToDateQty(sortField, sortOrder);
    }
  };
  handleSortingMonthToDateQty = (sortField, sortOrder) => {
    let list = this.state.lastSalesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ lastSalesList: sorted });
    }
  };
  handleSortingLastReceiptChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingLastReceipt(sortField, sortOrder);
    }
  };
  handleSortingLastReceipt = (sortField, sortOrder) => {
    let list = this.state.lastReceiptList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ lastReceiptList: sorted });
    }
  };
  handleSortingLastReturnChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingLastReturn(sortField, sortOrder);
    }
  };
  handleSortingLastReturn = (sortField, sortOrder) => {
    let list = this.state.lastReturnList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ lastReturnList: sorted });
    }
  };
  handleSortingCustomerQtyChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCustomerQty(sortField, sortOrder);
    }
  };
  handleSortingCustomerQty = (sortField, sortOrder) => {
    let list = this.state.customerQtyDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerQtyDataList: sorted });
    }
  };
  handleSortingVendorQtyChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingVendorQty(sortField, sortOrder);
    }
  };
  handleSortingVendorQty = (sortField, sortOrder) => {
    let list = this.state.vendorQtyDataList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ vendorQtyDataList: sorted });
    }
  };
  handleSortingCustomerLastSalesChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingCustomerLastSales(sortField, sortOrder);
    }
  };
  handleSortingCustomerLastSales = (sortField, sortOrder) => {
    let list = this.state.customerLastSalesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ customerLastSalesList: sorted });
    }
  };

  handleSortingSalesPersonLastSalesChange = (e, accessor) => {
    if (e.detail === 1) {
      let sortField = accessor;
      let order = this.state.order;
      let sortOrder =
        accessor === sortField && order === "asc" ? "desc" : "asc";
      this.setState({
        order: sortOrder,
        sortField: sortField,
      });
      this.handleSortingSalesPersonLastSales(sortField, sortOrder);
    }
  };
  handleSortingSalesPersonLastSales = (sortField, sortOrder) => {
    let list = this.state.salespersonLastSalesList;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ salespersonLastSalesList: sorted });
    }
  };
  render() {
    let inquiryDataList = this.state.inquiryDataList;
    let criteria = this.state.criteria;
    let fabricData = this.state.fabricData;
    let onHandQtyList = this.state.onHandQtyList;
    let onLocationList = this.state.onLocationList;
    let availableListToSaleList = this.state.availableListToSaleList;
    let customerSalesDetailList = this.state.customerSalesDetailList;
    let salesPersonSalesDetailList = this.state.salesPersonSalesDetailList;
    let customerQtyDataList = this.state.customerQtyDataList;
    let availableToSaleData = this.state.availableToSaleData;
    let onHandQtyData = this.state.onHandQtyData;
    let lastReceiptList = this.state.lastReceiptList;
    let lastSalesList = this.state.lastSalesList;
    let lastReturnList = this.state.lastReturnList;
    let vendorQtyDataList = this.state.vendorQtyDataList;
    let salespersonLastSalesList = this.state.salespersonLastSalesList;
    let customerLastSalesList = this.state.customerLastSalesList;
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        <BaseInquiryToolBar
          pageTitle={
            this.state.is3PL
              ? "Item Statistics Inquiry"
              : "Fabric Statistics Inquiry"
          }
          clearCriteria={this.clearCriteria}
          onModuleExit={this.moduleExit}
          execute={this.execute}
          isShowExecuteButton={this.state.isShowExecuteButton}
          isShowClearErrorButton={this.state.isShowClearErrorButton}
          isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
          isShowExitButton={this.state.isShowExitButton}
          isShowResetButton={this.state.isShowResetButton}
          clearError={this.clearError}
          reset={this.resetInquiry}
        />
        <CriteriaView
          {...this.state}
          onChange={this.onChange}
          fabricCodeRef={this.fabricCodeRef}
          fabricCodeOnChange={this.fabricCodeOnChange}
          fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
          displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
          fabricColourEnterKeyEventHandler={
            this.fabricColourEnterKeyEventHandler
          }
          displayAutoCompleteFabricColorList={
            this.displayAutoCompleteFabricColorList
          }
          onFabricColourCodeChange={this.onFabricColourCodeChange}
          showHideSecondHeader={this.showHideSecondHeader}
          onPatternTypeCodeChange={this.onPatternTypeCodeChange}
          patternTypeEnterKeyEvent={this.patternTypeEnterKeyEvent}
          onTypeCodeChange={this.onTypeCodeChange}
          typeEnterKeyEvent={this.typeEnterKeyEvent}
          onMakeTypeCodeChange={this.onMakeTypeCodeChange}
          makeTypeEnterKeyEvent={this.makeTypeEnterKeyEvent}
          displayAutoCompletePatternTypeList={
            this.displayAutoCompletePatternTypeList
          }
          displayAutoCompleteTypeList={this.displayAutoCompleteTypeList}
          displayAutoCompleteMakeTypeList={this.displayAutoCompleteMakeTypeList}
        />
        {this.state.isInquiryDatasFound && (
          <div className="">
            <div className="div_inline">
              <div className="div_30_no_overflow">
                <div className="header_div">
                  <Row className="d-flex justify-content-center">
                    <Col sm="2">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.searchFabric(e)}
                      >
                        {" "}
                        Search
                      </Button>
                    </Col>
                    <Col sm="2">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.resetFabric(e)}
                      >
                        Reset
                      </Button>
                    </Col>
                    <Col sm="2">
                      <Button
                        size="sm"
                        id="fabric_Add_Button"
                        onClick={(e) => this.generatePDF(e)}
                      >
                        PDF
                      </Button>
                    </Col>
                  </Row>
                </div>
                <div className="div_Custom_8">
                  <Table id="fabrics_tables">
                    <thead>
                      <tr>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "fabricStyleCode")
                          }
                        >
                          {this.state.is3PL ? "Item" : "Fabric"}

                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "fabricStyleName")
                          }
                        >
                          Name
                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleName" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "fabricStyleColorCode")
                          }
                        >
                          Color
                          {this.state.order === "desc" &&
                          this.state.sortField === "fabricStyleColorCode" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "lastReceivedDate")
                          }
                        >
                          LastRecdDate
                          {this.state.order === "desc" &&
                          this.state.sortField === "lastReceivedDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "LastSalesDate")
                          }
                        >
                          LastSalesDate
                          {this.state.order === "desc" &&
                          this.state.sortField === "LastSalesDate" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(e, "totalOnHandQuantity")
                          }
                        >
                          OnHandQty
                          {this.state.order === "desc" &&
                          this.state.sortField === "totalOnHandQuantity" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                        <th
                          onClick={(e) =>
                            this.handleSortingChange(
                              e,
                              "totalInventoryAverageAge"
                            )
                          }
                        >
                          InvAvgAge
                          {this.state.order === "desc" &&
                          this.state.sortField ===
                            "totalInventoryAverageAge" ? (
                            <span className="drp-dwn-cntr">
                              <DropDwnUp />
                            </span>
                          ) : (
                            <span className="drp-dwn-cntr">
                              <DropDwnDown />
                            </span>
                          )}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {inquiryDataList.map((inquiryInfo, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewFabricDetails(
                                  e,
                                  inquiryInfo.fabricStyleCode,
                                  inquiryInfo
                                )
                              }
                            >
                              {inquiryInfo.fabricStyleCode}
                            </Button>
                          </td>
                          <td>{inquiryInfo.fabricStyleName}</td>
                          <td>{inquiryInfo.fabricStyleColorCode}</td>
                          <td>{inquiryInfo.lastReceivedDate}</td>
                          <td>{inquiryInfo.LastSalesDate}</td>
                          <td className="text-right">
                            {toCommaSeperatedAmount(
                              inquiryInfo.totalOnHandQuantity
                            )}
                          </td>
                          <td>{inquiryInfo.totalInventoryAverageAge}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  {inquiryDataList.length != 0 ? null : (
                    <div className="no_Data_small">{"NO DATA"}</div>
                  )}
                </div>
              </div>
              <div className="div_70_no_overflow">
                <div className="div_inline">
                  <div className="div_60_no_overflow">
                    <div className="div_inline header_div">
                      <div className="div_Equal_no_height div_Custom_7">
                        <Row>
                          <FormLabel>
                            <span>
                              {this.state.is3PL
                                ? "Item Details"
                                : "FabricStyle Details"}
                            </span>
                          </FormLabel>
                        </Row>
                        <Row>
                          <Col sm="4">
                            <FormLabel>
                              {" "}
                              {this.state.is3PL ? "Item Code:" : "Fabric Code:"}
                            </FormLabel>
                          </Col>
                          <Col sm="8">
                            <FormLabel>
                              {" "}
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.viewFabricModule(
                                    e,
                                    fabricData.fabricStyleCode
                                  )
                                }
                              >
                                {fabricData.fabricStyleCode}
                              </Button>
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="4">
                            <FormLabel>Name :</FormLabel>
                          </Col>
                          <Col sm="8">
                            <FormLabel>{criteria.fabricStyleName}</FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="4">
                            <FormLabel>Color :</FormLabel>
                          </Col>
                          <Col sm="8">
                            <FormLabel>{fabricData.colorCode}</FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="4">
                            <FormLabel>Notes :</FormLabel>
                          </Col>
                          <Col sm="8">
                            <textarea
                              rows={2}
                              cols={15}
                              name="colorNotes"
                              value={fabricData.colorNotes}
                            />
                          </Col>
                        </Row>
                      </div>
                      <div className="div_Equal_no_height div_Custom_7">
                        <Row>
                          <FormLabel>
                            <span>Sales,Receipts,Return Details</span>
                          </FormLabel>
                        </Row>
                        <Row>
                          <Col sm="2"></Col>
                          <Col sm="2">
                            <FormLabel>Sales </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>Receipt </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>Return </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="2">
                            <FormLabel>03 Months</FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastSalesDetails(
                                    e,
                                    fabricData.last3MonthsSalesQuantity,
                                    3
                                  )
                                }
                              >
                                {fabricData.last3MonthsSalesQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReceiptDetails(
                                    e,
                                    fabricData.last3MonthsReceiptQuantity,
                                    3
                                  )
                                }
                              >
                                {fabricData.last3MonthsReceiptQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReturnDetails(
                                    e,
                                    fabricData.last3MonthsCreditReturnsQuantity,
                                    3
                                  )
                                }
                              >
                                {fabricData.last3MonthsCreditReturnsQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="2">
                            <FormLabel>06 Months</FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastSalesDetails(
                                    e,
                                    fabricData.last6MonthsSalesQuantity,
                                    6
                                  )
                                }
                              >
                                {fabricData.last6MonthsSalesQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReceiptDetails(
                                    e,
                                    fabricData.last6MonthsReceiptQuantity,
                                    6
                                  )
                                }
                              >
                                {fabricData.last6MonthsReceiptQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReturnDetails(
                                    e,
                                    fabricData.last6MonthsCreditReturnsQuantity,

                                    6
                                  )
                                }
                              >
                                {fabricData.last6MonthsCreditReturnsQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="2">
                            <FormLabel>12 Months</FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastSalesDetails(
                                    e,
                                    fabricData.last12MonthsSalesQuantity,
                                    12
                                  )
                                }
                              >
                                {fabricData.last12MonthsSalesQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReceiptDetails(
                                    e,
                                    fabricData.last12MonthsReceiptQuantity,
                                    12
                                  )
                                }
                              >
                                {fabricData.last12MonthsReceiptQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReturnDetails(
                                    e,
                                    fabricData.last12MonthsCreditReturnsQuantity,
                                    12
                                  )
                                }
                              >
                                {fabricData.last12MonthsCreditReturnsQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="2">
                            <FormLabel>18 Months</FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastSalesDetails(
                                    e,
                                    fabricData.last18MonthsSalesQuantity,
                                    18
                                  )
                                }
                              >
                                {fabricData.last18MonthsSalesQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReceiptDetails(
                                    e,
                                    fabricData.last18MonthsReceiptQuantity,
                                    18
                                  )
                                }
                              >
                                {fabricData.last18MonthsReceiptQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReturnDetails(
                                    e,
                                    fabricData.last18MonthsCreditReturnsQuantity,
                                    18
                                  )
                                }
                              >
                                {fabricData.last18MonthsCreditReturnsQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                        </Row>
                        <Row>
                          <Col sm="2">
                            <FormLabel>24 Months</FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastSalesDetails(
                                    e,
                                    fabricData.last24MonthsSalesQuantity,
                                    24
                                  )
                                }
                              >
                                {fabricData.last24MonthsSalesQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReceiptDetails(
                                    e,
                                    fabricData.last24MonthsReceiptQuantity,
                                    24
                                  )
                                }
                              >
                                {fabricData.last24MonthsReceiptQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                          <Col sm="2">
                            <FormLabel>
                              <Button
                                size="sm"
                                variant="secondry"
                                className="hyperLinkText"
                                onClick={(e) =>
                                  this.lastReturnDetails(
                                    e,
                                    fabricData.last24MonthsCreditReturnsQuantity,
                                    24
                                  )
                                }
                              >
                                {fabricData.last24MonthsCreditReturnsQuantity}
                              </Button>
                            </FormLabel>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                  <div className="div_40_no_overflow">
                    <Row>
                      <Col>
                        <FormLabel>
                          OnHand Details -TotQty :{" "}
                          {fabricData.totalOnHandQuatity};Rolls :{" "}
                          {fabricData.totalNoOfRolls}
                        </FormLabel>
                      </Col>
                    </Row>
                    <div className="table_small">
                      <Table id="fabrics_tables">
                        <thead>
                          <th
                            onClick={(e) =>
                              this.handleSortingOnHandQtyChange(
                                e,
                                "locationCode"
                              )
                            }
                          >
                            Location
                            {this.state.order === "desc" &&
                            this.state.sortField === "locationCode" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingOnHandQtyChange(
                                e,
                                "onHandQuatity"
                              )
                            }
                          >
                            OnHandQty
                            {this.state.order === "desc" &&
                            this.state.sortField === "onHandQuatity" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingOnHandQtyChange(e, "noOfRolls")
                            }
                          >
                            No.Rolls
                            {this.state.order === "desc" &&
                            this.state.sortField === "noOfRolls" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                        </thead>
                        {!isEmptyArray(onHandQtyList) && (
                          <tbody>
                            {onHandQtyList.map((qty, index) => (
                              <tr key={index}>
                                <td>
                                  <Button
                                    size="sm"
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.onLocationClick(
                                        e,
                                        qty.locationCode,
                                        qty
                                      )
                                    }
                                  >
                                    {qty.locationCode}
                                  </Button>
                                </td>
                                <td>{qty.onHandQuatity}</td>
                                <td>{qty.noOfRolls}</td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </Table>

                      {isEmptyArray(onHandQtyList) && (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                    <Row>
                      <Col sm="6">
                        <FormLabel>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.totalCustomerOnOrderQtyClick(
                                e,
                                fabricData.totalCustomerOnOrderQuantity
                              )
                            }
                          >
                            Total Customer OnOrder
                          </Button>
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <InputTextbox
                          name="totalCustomerOnOrderQuantity"
                          className="text-right"
                          value={fabricData.totalCustomerOnOrderQuantity}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col sm="6">
                        <FormLabel>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.totalVendorOnOrderQtyClick(
                                e,
                                fabricData.totalVendorOnOrderQuantity
                              )
                            }
                          >
                            Total Vendor OnOrder
                          </Button>
                        </FormLabel>
                      </Col>
                      <Col sm="6">
                        <InputTextbox
                          name="totalVendorOnOrderQuantity"
                          className="text-right"
                          value={fabricData.totalVendorOnOrderQuantity}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <FormLabel>Available To Sale</FormLabel>
                      </Col>
                    </Row>
                    <div className="table_small">
                      <Table id="fabrics_tables">
                        <thead>
                          <tr>
                            <th
                              onClick={(e) =>
                                this.handleSortingAvailableToSaleChange(
                                  e,
                                  "displayName"
                                )
                              }
                            >
                              {this.state.order === "desc" &&
                              this.state.sortField === "displayName" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingAvailableToSaleChange(
                                  e,
                                  "beginingBalanceAmount"
                                )
                              }
                            >
                              Begin Balance
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "beginingBalanceAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingAvailableToSaleChange(
                                  e,
                                  "onHandQuantity"
                                )
                              }
                            >
                              OnHand Qty
                              {this.state.order === "desc" &&
                              this.state.sortField === "onHandQuantity" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingAvailableToSaleChange(
                                  e,
                                  "salesOnOrderQuantity"
                                )
                              }
                            >
                              Customer OnOrder
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "salesOnOrderQuantity" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingAvailableToSaleChange(
                                  e,
                                  "purchaseOnOrderQuantity"
                                )
                              }
                            >
                              Vendor OnOrder
                              {this.state.order === "desc" &&
                              this.state.sortField ===
                                "purchaseOnOrderQuantity" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                            <th
                              onClick={(e) =>
                                this.handleSortingAvailableToSaleChange(
                                  e,
                                  "endBalanceAmount"
                                )
                              }
                            >
                              End Balance
                              {this.state.order === "desc" &&
                              this.state.sortField === "endBalanceAmount" ? (
                                <span className="drp-dwn-cntr">
                                  <DropDwnUp />
                                </span>
                              ) : (
                                <span className="drp-dwn-cntr">
                                  <DropDwnDown />
                                </span>
                              )}
                            </th>
                          </tr>
                        </thead>
                        {!isEmptyArray(availableListToSaleList) && (
                          <tbody>
                            {availableListToSaleList.map((list, index) => (
                              <tr key={index}>
                                <td>{list.displayName}</td>
                                <td>{list.beginingBalanceAmount}</td>
                                <td className="text-right">
                                  {toCommaSeperatedAmount(list.onHandQuantity)}
                                </td>
                                <td className="text-right">
                                  <Button
                                    size="sm"
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.customerOnOrderQtyClick(
                                        e,
                                        list.salesOnOrderQuantity,
                                        list
                                      )
                                    }
                                  >
                                    {toCommaSeperatedAmount(
                                      list.salesOnOrderQuantity
                                    )}
                                  </Button>
                                </td>
                                <td className="text-right">
                                  <Button
                                    size="sm"
                                    variant="secondry"
                                    className="hyperLinkText"
                                    onClick={(e) =>
                                      this.vendorOnOrderQtyClick(
                                        e,
                                        list.purchaseOnOrderQuantity,
                                        list
                                      )
                                    }
                                  >
                                    {toCommaSeperatedAmount(
                                      list.purchaseOnOrderQuantity
                                    )}
                                  </Button>
                                </td>
                                <td className="text-right">
                                  {toCommaSeperatedAmount(
                                    list.endBalanceAmount
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        )}
                      </Table>
                      {isEmptyArray(availableListToSaleList) && (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="">
                  <Row>
                    <Col sm="6">
                      <FormLabel>Customer Sales Detail</FormLabel>
                    </Col>
                    <Col sm="6">
                      <FormLabel>SalesPerson Sales Detail</FormLabel>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="6">
                      <div className="div_Custom_3">
                        <Table id="fabrics_tables">
                          <thead>
                            <tr>
                              <th
                                onClick={(e) =>
                                  this.handleSortingCustomerSalesDetailChange(
                                    e,
                                    "customerCode"
                                  )
                                }
                              >
                                Customer
                                {this.state.order === "desc" &&
                                this.state.sortField === "customerCode" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingCustomerSalesDetailChange(
                                    e,
                                    "last3MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last03Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last3MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingCustomerSalesDetailChange(
                                    e,
                                    "last6MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last06Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last6MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingCustomerSalesDetailChange(
                                    e,
                                    "last12MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last12Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last12MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingCustomerSalesDetailChange(
                                    e,
                                    "last18MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last18Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last18MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                            </tr>
                          </thead>
                          {customerSalesDetailList != null && (
                            <tbody>
                              {customerSalesDetailList.map((data, index) => (
                                <tr key={index}>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewCustomerModule(
                                          e,
                                          data.customerCode
                                        )
                                      }
                                    >
                                      {data.customerCode}
                                    </Button>
                                  </td>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewCustomerLastSalesDetail(
                                          e,
                                          data.last3MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          3
                                        )
                                      }
                                    >
                                      {
                                        data.last3MonthsPeriodSalesQuantity
                                          .scalarValue
                                      }
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewCustomerLastSalesDetail(
                                          e,
                                          data.last6MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          6
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        data.last6MonthsPeriodSalesQuantity
                                          .scalarValue
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewCustomerLastSalesDetail(
                                          e,
                                          data.last12MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          12
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        data.last12MonthsPeriodSalesQuantity
                                          .scalarValue
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewCustomerLastSalesDetail(
                                          e,
                                          data.last18MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          18
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        data.last18MonthsPeriodSalesQuantity
                                          .scalarValue
                                      )}
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </Table>
                        {isEmptyArray(customerSalesDetailList) && (
                          <div className="no_Data_small">{"NO DATA"}</div>
                        )}
                      </div>
                    </Col>
                    <Col sm="6">
                      <div className="div_Custom_3">
                        <Table id="fabrics_tables">
                          <thead>
                            <tr>
                              <th
                                onClick={(e) =>
                                  this.handleSortingSalesPersonSalesDetailChange(
                                    e,
                                    "salesPersonCode"
                                  )
                                }
                              >
                                SalesPerson
                                {this.state.order === "desc" &&
                                this.state.sortField === "salesPersonCode" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingSalesPersonSalesDetailChange(
                                    e,
                                    "last3MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last03Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last3MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingSalesPersonSalesDetailChange(
                                    e,
                                    "last6MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last06Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last6MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingSalesPersonSalesDetailChange(
                                    e,
                                    "last12MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last12Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last12MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                              <th
                                onClick={(e) =>
                                  this.handleSortingSalesPersonSalesDetailChange(
                                    e,
                                    "last18MonthsPeriodSalesQuantity"
                                  )
                                }
                              >
                                Last18Months
                                {this.state.order === "desc" &&
                                this.state.sortField ===
                                  "last18MonthsPeriodSalesQuantity" ? (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnUp />
                                  </span>
                                ) : (
                                  <span className="drp-dwn-cntr">
                                    <DropDwnDown />
                                  </span>
                                )}
                              </th>
                            </tr>
                          </thead>
                          {salesPersonSalesDetailList != null && (
                            <tbody>
                              {salesPersonSalesDetailList.map((data, index) => (
                                <tr key={index}>
                                  <td>{data.salesPersonCode}</td>
                                  <td>
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewSalesPersonLastSalesDetail(
                                          e,
                                          data.last3MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          3
                                        )
                                      }
                                    >
                                      {
                                        data.last3MonthsPeriodSalesQuantity
                                          .scalarValue
                                      }
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewSalesPersonLastSalesDetail(
                                          e,
                                          data.last6MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          6
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        data.last6MonthsPeriodSalesQuantity
                                          .scalarValue
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewSalesPersonLastSalesDetail(
                                          e,
                                          data.last12MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          12
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        data.last12MonthsPeriodSalesQuantity
                                          .scalarValue
                                      )}
                                    </Button>
                                  </td>
                                  <td className="text-right">
                                    <Button
                                      variant="secondry"
                                      className="td_fabricCode_width text-left"
                                      onClick={(e) =>
                                        this.viewSalesPersonLastSalesDetail(
                                          e,
                                          data.last18MonthsPeriodSalesQuantity
                                            .scalarValue,
                                          data,
                                          18
                                        )
                                      }
                                    >
                                      {toCommaSeperatedAmount(
                                        data.last18MonthsPeriodSalesQuantity
                                          .scalarValue
                                      )}
                                    </Button>
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          )}
                        </Table>
                        {isEmptyArray(salesPersonSalesDetailList) && (
                          <div className="no_Data_small">{"NO DATA"}</div>
                        )}
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        )}
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowOnHandQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"OnHandQty :: Location Based"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={fabricData.colorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Location</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={onHandQtyData.locationCode}
                    name={"locationCode"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Row>
                <Col sm="1">
                  <FormLabel>Total</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={onHandQtyData.onHandQuatity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQuantity"}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>Total Rolls</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={onHandQtyData.noOfRolls}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalOnHandQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(e, "rollSkuNumber")
                        }
                      >
                        RollSKU#
                        {this.state.order === "desc" &&
                        this.state.sortField === "rollSkuNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(
                            e,
                            "onHandQuantity"
                          )
                        }
                      >
                        OnHandQty#
                        {this.state.order === "desc" &&
                        this.state.sortField === "onHandQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(
                            e,
                            "purchaseOrderNumber"
                          )
                        }
                      >
                        PO#
                        {this.state.order === "desc" &&
                        this.state.sortField === "purchaseOrderNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(
                            e,
                            "purchaseOrderReceiptNumber"
                          )
                        }
                      >
                        Receipt#
                        {this.state.order === "desc" &&
                        this.state.sortField ===
                          "purchaseOrderReceiptNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(e, "aisleInfoText")
                        }
                      >
                        BinLoc#
                        {this.state.order === "desc" &&
                        this.state.sortField === "aisleInfoText" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(
                            e,
                            "vendorBatchNumber"
                          )
                        }
                      >
                        Lot Number
                        {this.state.order === "desc" &&
                        this.state.sortField === "vendorBatchNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingOnLocationChange(e, "rollNumber")
                        }
                      >
                        Roll Number
                        {this.state.order === "desc" &&
                        this.state.sortField === "rollNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {onLocationList.map((data, index) => (
                      <tr key={index}>
                        <td className="text-right">{data.rollSkuNumber}</td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(data.onHandQuantity)}
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewPoModule(e, data.purchaseOrderNumber)
                            }
                          >
                            {data.purchaseOrderNumber}
                          </Button>
                        </td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewPurchaseReceiptModule(
                                e,
                                data.purchaseOrderReceiptNumber
                              )
                            }
                          >
                            {data.purchaseOrderReceiptNumber}
                          </Button>
                        </td>

                        <td>{data.aisleInfoText}</td>
                        <td>{data.vendorBatchNumber}</td>
                        <td>{data.rollNumber}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {onLocationList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowVendorQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"VendorOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={fabricData.colorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OnOrderQty</FormLabel>
                </Col>
                {this.state.isShowTotalOnOrder && (
                  <Col sm="2">
                    <NumberFormatInputbox
                      value={fabricData.totalVendorOnOrderQuantity}
                      className="qty_input text-right"
                      decimalScale={2}
                      name={"totalCustOnOrderQuantity"}
                      disabled={true}
                    />
                  </Col>
                )}
                {!this.state.isShowTotalOnOrder && (
                  <Col sm="2">
                    <NumberFormatInputbox
                      value={availableToSaleData.purchaseOnOrderQuantity}
                      className="qty_input text-right"
                      decimalScale={2}
                      name={"totalCustOnOrderQuantity"}
                      disabled={true}
                    />
                  </Col>
                )}
              </Row>
              <Row>
                <Col>
                  {" "}
                  <FormLabel>Order Details</FormLabel>
                  <div className="div_default">
                    <Table id="fabrics_tables">
                      <thead>
                        <tr>
                          <th
                            onClick={(e) =>
                              this.handleSortingVendorQtyChange(e, "vendorCode")
                            }
                          >
                            Vendor#
                            {this.state.order === "desc" &&
                            this.state.sortField === "vendorCode" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingVendorQtyChange(e, "vendorName")
                            }
                          >
                            VendorName
                            {this.state.order === "desc" &&
                            this.state.sortField === "vendorName" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingVendorQtyChange(
                                e,
                                "purchaseOrderNumber"
                              )
                            }
                          >
                            PO#
                            {this.state.order === "desc" &&
                            this.state.sortField === "purchaseOrderNumber" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingVendorQtyChange(
                                e,
                                "purchaseOrderStopDate"
                              )
                            }
                          >
                            OrderStopDate
                            {this.state.order === "desc" &&
                            this.state.sortField === "purchaseOrderStopDate" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingVendorQtyChange(
                                e,
                                "onOrderQuantity"
                              )
                            }
                          >
                            Open OrderQty
                            {this.state.order === "desc" &&
                            this.state.sortField === "onOrderQuantity" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                          <th
                            onClick={(e) =>
                              this.handleSortingVendorQtyChange(
                                e,
                                "purchaseOrderStartDate"
                              )
                            }
                          >
                            OrderDate
                            {this.state.order === "desc" &&
                            this.state.sortField ===
                              "purchaseOrderStartDate" ? (
                              <span className="drp-dwn-cntr">
                                <DropDwnUp />
                              </span>
                            ) : (
                              <span className="drp-dwn-cntr">
                                <DropDwnDown />
                              </span>
                            )}
                          </th>
                        </tr>
                      </thead>
                      {vendorQtyDataList != null && (
                        <tbody>
                          {vendorQtyDataList.map((data, index) => (
                            <tr key={index}>
                              <td>
                                <Button
                                  size="sm"
                                  variant="secondry"
                                  className="hyperLinkText"
                                  onClick={(e) =>
                                    this.viewVendorModule(e, data.vendorCode)
                                  }
                                >
                                  {data.vendorCode}
                                </Button>
                              </td>
                              <td>{data.vendorName}</td>
                              <td>
                                <Button
                                  size="sm"
                                  variant="secondry"
                                  className="hyperLinkText"
                                  onClick={(e) =>
                                    this.viewPoModule(
                                      e,
                                      data.purchaseOrderNumber
                                    )
                                  }
                                >
                                  {data.purchaseOrderNumber}
                                </Button>
                              </td>
                              <td>{data.purchaseOrderStopDate}</td>
                              <td className="text-right">
                                {toCommaSeperatedAmount(data.onOrderQuantity)}
                              </td>
                              <td>
                                <td>{data.purchaseOrderStartDate}</td>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </Table>
                    {vendorQtyDataList.length != 0 ? null : (
                      <div className="no_Data">{"NO DATA"}</div>
                    )}
                  </div>
                </Col>
              </Row>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerQtyPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"CustomerOnOrderDetails"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div>
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={fabricData.colorCode}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>OnOrderQty</FormLabel>
                </Col>
                {this.state.isShowTotalOnOrder && (
                  <Col sm="2">
                    <NumberFormatInputbox
                      value={fabricData.totalCustomerOnOrderQuantity}
                      className="qty_input text-right"
                      decimalScale={2}
                      name={"totalCustOnOrderQuantity"}
                      disabled={true}
                    />
                  </Col>
                )}
                {!this.state.isShowTotalOnOrder && (
                  <Col sm="2">
                    <NumberFormatInputbox
                      value={availableToSaleData.salesOnOrderQuantity}
                      className="qty_input text-right"
                      decimalScale={2}
                      name={"totalCustOnOrderQuantity"}
                      disabled={true}
                    />
                  </Col>
                )}
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(e, "customerCode")
                        }
                      >
                        Customer#
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(e, "customerName")
                        }
                      >
                        CustomerName
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerName" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(
                            e,
                            "onOrderQuantity"
                          )
                        }
                      >
                        OpenOrderQty
                        {this.state.order === "desc" &&
                        this.state.sortField === "onOrderQuantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(
                            e,
                            "customerPONumber"
                          )
                        }
                      >
                        CustomerPO#
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerPONumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(
                            e,
                            "salesOrderNumber"
                          )
                        }
                      >
                        SalesOrder#
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(
                            e,
                            "salesOrderDate"
                          )
                        }
                      >
                        S.O Date
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingCustomerQtyChange(
                            e,
                            "salesOrderStartDate"
                          )
                        }
                      >
                        SO StartDate
                        {this.state.order === "desc" &&
                        this.state.sortField === "salesOrderStartDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {customerQtyDataList.map((data, index) => (
                      <tr key={index}>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewCustomerModule(e, data.customerCode)
                            }
                          >
                            {data.customerCode}
                          </Button>
                        </td>
                        <td>{data.customerName}</td>
                        <td className="text-right">
                          {toCommaSeperatedAmount(data.onOrderQuantity)}
                        </td>
                        <td>{data.customerPONumber}</td>
                        <td>
                          <Button
                            size="sm"
                            variant="secondry"
                            className="hyperLinkText"
                            onClick={(e) =>
                              this.viewSalesModule(e, data.salesOrderNumber)
                            }
                          >
                            {data.salesOrderNumber}
                          </Button>
                        </td>
                        <td>{data.salesOrderDate}</td>
                        <td>{data.salesOrderStartDate}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                {customerQtyDataList.length != 0 ? null : (
                  <div className="no_Data">{"NO DATA"}</div>
                )}
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLastReceiptDetailsPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Last Receipt Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleColorCode"
                    type="text"
                    value={fabricData.colorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OnOrderQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={fabricData.totalVendorOnOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalCustOnOrderQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Table id="fabrics_tables">
                <thead>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(e, "vendorCode")
                    }
                  >
                    Vendor
                    {this.state.order === "desc" &&
                    this.state.sortField === "vendorCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(
                        e,
                        "purchaseReceiptDate"
                      )
                    }
                  >
                    ReceiptDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "purchaseReceiptDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(
                        e,
                        "purchaseOrderReceiptNumber"
                      )
                    }
                  >
                    PR#
                    {this.state.order === "desc" &&
                    this.state.sortField === "purchaseOrderReceiptNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(e, "lineNumber")
                    }
                  >
                    Ln#
                    {this.state.order === "desc" &&
                    this.state.sortField === "lineNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(e, "quantity")
                    }
                  >
                    Qty
                    {this.state.order === "desc" &&
                    this.state.sortField === "quantity" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(e, "uomCode")
                    }
                  >
                    UOM
                    {this.state.order === "desc" &&
                    this.state.sortField === "uomCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(
                        e,
                        "purchaseOrderNumber"
                      )
                    }
                  >
                    PO#
                    {this.state.order === "desc" &&
                    this.state.sortField === "purchaseOrderNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingLastReceiptChange(e, "noOfRolls")
                    }
                  >
                    No.Rolls
                    {this.state.order === "desc" &&
                    this.state.sortField === "noOfRolls" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {lastReceiptList.map((list, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewVendorModule(e, list.vendorCode)
                          }
                        >
                          {list.vendorCode}
                        </Button>
                      </td>
                      <td> {list.purchaseReceiptDate}</td>

                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewPurchaseReceiptModule(
                              e,
                              list.purchaseOrderReceiptNumber
                            )
                          }
                        >
                          {list.purchaseOrderReceiptNumber}
                        </Button>
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(list.lineNumber)}
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(list.quantity)}
                      </td>
                      <td>{list.uomCode}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewPoModule(e, list.purchaseOrderNumber)
                          }
                        >
                          {list.purchaseOrderNumber}
                        </Button>
                      </td>
                      <td>{list.noOfRolls}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {lastReceiptList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLastSalesDetailPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Last Sales Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={fabricData.colorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OrderQuantity</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={fabricData.totalCustomerOnOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(
                            e,
                            "customerCode"
                          )
                        }
                      >
                        Customer#
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(
                            e,
                            "customerName"
                          )
                        }
                      >
                        CustomerName
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerName" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(
                            e,
                            "invoiceDate"
                          )
                        }
                      >
                        Date
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(
                            e,
                            "invoiceNumber"
                          )
                        }
                      >
                        Invoice#
                        {this.state.order === "desc" &&
                        this.state.sortField === "invoiceNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(
                            e,
                            "lineNumber"
                          )
                        }
                      >
                        Ln#
                        {this.state.order === "desc" &&
                        this.state.sortField === "lineNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(e, "quantity")
                        }
                      >
                        Qty
                        {this.state.order === "desc" &&
                        this.state.sortField === "quantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(e, "uomCode")
                        }
                      >
                        UOM
                        {this.state.order === "desc" &&
                        this.state.sortField === "uomCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingMonthToDateQtyChange(e, "noOfRolls")
                        }
                      >
                        No.Rolls
                        {this.state.order === "desc" &&
                        this.state.sortField === "noOfRolls" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {lastSalesList != null && (
                    <tbody>
                      {lastSalesList.map((data, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewCustomerModule(e, data.customerCode)
                              }
                            >
                              {data.customerCode}
                            </Button>
                          </td>
                          <td>{data.customerName}</td>
                          <td>{data.invoiceDate}</td>
                          <td>
                            <Button
                              size="sm"
                              text="right"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewInvoiceModule(e, data.invoiceNumber)
                              }
                            >
                              {data.invoiceNumber}
                            </Button>
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(data.lineNumber)}
                          </td>
                          <td className="text-right">
                            {toCommaSeperatedAmount(data.quantity)}
                          </td>
                          <td>{data.uomCode}</td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(data.noOfRolls)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowLastReturnDetailPopup}
          closeOnEsc={false}
          popupLvlClass={"popupSizeLevel0"}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Last Return Detail"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowAlert}
              hideAlertCallBack={this.hideAlertCallBack}
            />
          }
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>{" "}
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleCode"
                    type="text"
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="fabricStyleName"
                    type="text"
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>ColorCode</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    name="colorCode"
                    type="text"
                    value={fabricData.colorCode}
                    disabled={true}
                  />
                </Col>
                <Col sm="1">
                  <FormLabel>OrderQuantity</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={fabricData.totalCustomerOnOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    disabled={true}
                  />
                </Col>
              </Row>
              <div className="div_default">
                <Table id="fabrics_tables">
                  <thead>
                    <tr>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(e, "customerCode")
                        }
                      >
                        Customer#
                        {this.state.order === "desc" &&
                        this.state.sortField === "customerCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(
                            e,
                            "creditMemoDate"
                          )
                        }
                      >
                        Date
                        {this.state.order === "desc" &&
                        this.state.sortField === "creditMemoDate" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(
                            e,
                            "creditMemoNumber"
                          )
                        }
                      >
                        CreditMemo#
                        {this.state.order === "desc" &&
                        this.state.sortField === "creditMemoNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(e, "lineNumber")
                        }
                      >
                        Ln#
                        {this.state.order === "desc" &&
                        this.state.sortField === "lineNumber" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(e, "quantity")
                        }
                      >
                        Qty
                        {this.state.order === "desc" &&
                        this.state.sortField === "quantity" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(e, "uomCode")
                        }
                      >
                        UOM
                        {this.state.order === "desc" &&
                        this.state.sortField === "uomCode" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                      <th
                        onClick={(e) =>
                          this.handleSortingLastReturnChange(e, "noOfRolls")
                        }
                      >
                        No.Rolls
                        {this.state.order === "desc" &&
                        this.state.sortField === "noOfRolls" ? (
                          <span className="drp-dwn-cntr">
                            <DropDwnUp />
                          </span>
                        ) : (
                          <span className="drp-dwn-cntr">
                            <DropDwnDown />
                          </span>
                        )}
                      </th>
                    </tr>
                  </thead>
                  {lastReturnList != null && (
                    <tbody>
                      {lastReturnList.map((data, index) => (
                        <tr key={index}>
                          <td>
                            <Button
                              size="sm"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewCustomerModule(e, data.customerCode)
                              }
                            >
                              {data.customerCode}
                            </Button>
                          </td>
                          <td>{data.creditMemoDate}</td>
                          <td>
                            <Button
                              size="sm"
                              text="right"
                              variant="secondry"
                              className="hyperLinkText"
                              onClick={(e) =>
                                this.viewCreditMemoModule(
                                  e,
                                  data.creditMemoNumber
                                )
                              }
                            >
                              {data.creditMemoNumber}
                            </Button>
                          </td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(data.lineNumber)}
                          </td>
                          <td className="text-right">
                            {toCommaSeperatedAmount(data.quantity)}
                          </td>
                          <td>{data.uomCode}</td>
                          <td class="text-right">
                            {toCommaSeperatedAmount(data.noOfRolls)}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  )}
                </Table>
              </div>
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowCustomerLastSalesDetailsPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Customer :: Last Sales Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>

                <Col sm="2">
                  <InputTextbox
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox value={fabricData.colorCode} disabled={true} />
                </Col>

                <Col sm="1">
                  <FormLabel>OnOrderQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={fabricData.totalCustomerOnOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalCustOnOrderQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Table id="fabrics_tables">
                <thead>
                  <th
                    onClick={(e) =>
                      this.handleSortingCustomerLastSalesChange(
                        e,
                        "customerCode"
                      )
                    }
                  >
                    Customer
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCustomerLastSalesChange(
                        e,
                        "invoiceDate"
                      )
                    }
                  >
                    InvoiceDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCustomerLastSalesChange(
                        e,
                        "invoiceNumber"
                      )
                    }
                  >
                    Invoice#
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCustomerLastSalesChange(
                        e,
                        "invoiceQuantity"
                      )
                    }
                  >
                    Qty
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceQuantity" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingCustomerLastSalesChange(e, "price")
                    }
                  >
                    Price
                    {this.state.order === "desc" &&
                    this.state.sortField === "price" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {customerLastSalesList.map((list, index) => (
                    <tr key={index}>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerModule(e, list.customerCode)
                          }
                        >
                          {list.customerCode}
                        </Button>
                      </td>
                      <td>{list.invoiceDate}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewInvoiceModule(e, list.invoiceNumber)
                          }
                        >
                          {list.invoiceNumber}
                        </Button>
                      </td>
                      <td className="text-right">
                        {" "}
                        {toCommaSeperatedAmount(list.invoiceQuantity)}
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(list.price)}{" "}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {customerLastSalesList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={false}
          isShowPopup={this.state.isShowSalesPersonLastSalesDetailsPopup}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"SalesPerson :: Last Sales Details"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          content={
            <div className="">
              <Row>
                <Col sm="1">
                  <FormLabel>{this.state.is3PL ? "Item" : "Fabric"}</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox
                    value={fabricData.fabricStyleCode}
                    disabled={true}
                  />
                </Col>

                <Col sm="2">
                  <InputTextbox
                    value={criteria.fabricStyleName}
                    disabled={true}
                  />
                </Col>

                <Col sm="1">
                  <FormLabel>Color</FormLabel>
                </Col>
                <Col sm="2">
                  <InputTextbox value={fabricData.colorCode} disabled={true} />
                </Col>

                <Col sm="1">
                  <FormLabel>OnOrderQty</FormLabel>
                </Col>
                <Col sm="2">
                  <NumberFormatInputbox
                    value={fabricData.totalCustomerOnOrderQuantity}
                    className="qty_input text-right"
                    decimalScale={2}
                    name={"totalCustOnOrderQuantity"}
                    disabled={true}
                  />
                </Col>
              </Row>
              <Table id="fabrics_tables">
                <thead>
                  <th
                    onClick={(e) =>
                      this.handleSortingSalesPersonLastSalesChange(
                        e,
                        "salesPersonCode"
                      )
                    }
                  >
                    salesPerson
                    {this.state.order === "desc" &&
                    this.state.sortField === "salesPersonCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingSalesPersonLastSalesChange(
                        e,
                        "customerCode"
                      )
                    }
                  >
                    Customer
                    {this.state.order === "desc" &&
                    this.state.sortField === "customerCode" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingSalesPersonLastSalesChange(
                        e,
                        "invoiceDate"
                      )
                    }
                  >
                    InvoiceDate
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceDate" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingSalesPersonLastSalesChange(
                        e,
                        "invoiceNumber"
                      )
                    }
                  >
                    Invoice#
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceNumber" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                  <th
                    onClick={(e) =>
                      this.handleSortingSalesPersonLastSalesChange(
                        e,
                        "invoiceQuantity"
                      )
                    }
                  >
                    Qty
                    {this.state.order === "desc" &&
                    this.state.sortField === "invoiceQuantity" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>

                  <th
                    onClick={(e) =>
                      this.handleSortingSalesPersonLastSalesChange(e, "price")
                    }
                  >
                    Price
                    {this.state.order === "desc" &&
                    this.state.sortField === "price" ? (
                      <span className="drp-dwn-cntr">
                        <DropDwnUp />
                      </span>
                    ) : (
                      <span className="drp-dwn-cntr">
                        <DropDwnDown />
                      </span>
                    )}
                  </th>
                </thead>
                <tbody>
                  {salespersonLastSalesList.map((list, index) => (
                    <tr key={index}>
                      <td> {list.salesPersonCode}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewCustomerModule(e, list.customerCode)
                          }
                        >
                          {list.customerCode}
                        </Button>
                      </td>
                      <td>{list.invoiceDate}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="secondry"
                          className="hyperLinkText"
                          onClick={(e) =>
                            this.viewInvoiceModule(e, list.invoiceNumber)
                          }
                        >
                          {list.invoiceNumber}
                        </Button>
                      </td>
                      <td className="text-right">
                        {" "}
                        {toCommaSeperatedAmount(list.invoiceQuantity)}
                      </td>
                      <td className="text-right">
                        {toCommaSeperatedAmount(list.price)}{" "}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              {salespersonLastSalesList.length != 0 ? null : (
                <div className="no_Data">{"NO DATA"}</div>
              )}
            </div>
          }
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowSalesModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseOrderModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowPurchaseReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowCreditMemoModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel0"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        />
      </div>
    );
  }
}
export function CriteriaView(props) {
  const fabricCodeOnChange = (e) => props.fabricCodeOnChange(e);
  const onFabricColourCodeChange = (e) => {
    props.onFabricColourCodeChange(e);
  };
  const onChange = (e) => props.onChange(e);
  let colorCodeRef = React.createRef();
  let criteria = props.criteria;
  let fabricLookupHandler = props.fabricLookupHandler;
  const fabricCodeRef = props.fabricCodeRef;
  const fabricEnterKeyEventHandler = (e) => {
    props.fabricEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricList = () => {
    props.displayAutoCompleteFabricList();
  };
  const fabricColourEnterKeyEventHandler = (e) => {
    props.fabricColourEnterKeyEventHandler(e);
  };
  const displayAutoCompleteFabricColorList = () => {
    props.displayAutoCompleteFabricColorList();
  };
  const onPatternTypeCodeChange = (e) => {
    props.onPatternTypeCodeChange(e);
  };
  const patternTypeEnterKeyEvent = (e) => {
    props.patternTypeEnterKeyEvent(e);
  };
  const displayAutoCompletePatternTypeList = (list) => {
    props.displayAutoCompletePatternTypeList(list);
  };
  const onTypeCodeChange = (e) => {
    props.onTypeCodeChange(e);
  };
  const typeEnterKeyEvent = (e) => {
    props.typeEnterKeyEvent(e);
  };
  const onMakeTypeCodeChange = (e) => {
    props.onMakeTypeCodeChange(e);
  };
  const makeTypeEnterKeyEvent = (e) => {
    props.makeTypeEnterKeyEvent(e);
  };
  const displayAutoCompleteTypeList = (list) => {
    props.displayAutoCompleteTypeList(list);
  };
  const displayAutoCompleteMakeTypeList = (list) => {
    props.displayAutoCompleteMakeTypeList(list);
  };
  return (
    <div>
      <Row className="d-flex justify-context-left">
        <Col sm="1">
          <FormLabel>{props.is3PL ? "Item" : "Fabric"}</FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={fabricCodeRef}
            name="fabricStyleCode"
            value={criteria.fabricStyleCode}
            lookupRequired={props.isShowLookUp}
            showCriteriaDialog={true}
            onChange={fabricCodeOnChange}
            lookupHandler={fabricLookupHandler}
            enterKeyEventHandler={fabricEnterKeyEventHandler}
            autoCompleteListData={props.fabricPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricList}
            showAutoCompleteList={props.showAutoCompleteFabricList}
            disabled={!props.isShowLookUp}
            isMandatory={true}
          />
        </Col>
        <Col sm="2">
          <InputTextbox
            disabled={true}
            name="fabricStyleName"
            onChange={onChange}
            value={criteria.fabricStyleName}
          />
        </Col>
        <Col sm="1">
          <FormLabel> color </FormLabel>
        </Col>
        <Col sm="2">
          <InputTextbox
            ref={colorCodeRef}
            onChange={onFabricColourCodeChange}
            name="fabricStyleColorCode"
            placeholder="color"
            value={criteria.fabricStyleColorCode}
            lookupRequired={props.isShowColorLookup}
            lookupHandler={props.colorLookupHandler}
            enterKeyEventHandler={fabricColourEnterKeyEventHandler}
            autoCompleteListData={props.fabricColourPageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompleteFabricColorList}
            showAutoCompleteList={props.showAutoCompleteFabricColorList}
            disabled={!props.isShowColorLookup}
          />
        </Col>

        <Col sm="1">
          <FormLabel>Style </FormLabel>{" "}
        </Col>
        <Col sm="2">
          <InputTextbox
            onChange={onPatternTypeCodeChange}
            name="productTypeCode"
            value={criteria.productTypeCode}
            lookupRequired={true}
            lookupHandler={props.productTypeLookupHandler}
            enterKeyEventHandler={patternTypeEnterKeyEvent}
            autoCompleteListData={props.patternTypePageListForAutoCompleteList}
            enableAutoCompleteTextBox={true}
            displayAutoCompleteList={displayAutoCompletePatternTypeList}
            showAutoCompleteList={props.showAutoCompletePatternTypeList}
            disabled={props.isDisableFields}
            isMandatory={true}
          ></InputTextbox>
        </Col>
        <Col>
          <CollapseComponent
            isOpen={props.isCollapsible_open}
            onClick={(e) => props.showHideSecondHeader(e)}
          />
        </Col>
      </Row>
      {props.isCollapsible_open && (
        <Row>
          <Col sm="1">
            <FormLabel>Type </FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onTypeCodeChange}
              name="patternTypeCode"
              value={criteria.patternTypeCode}
              lookupRequired={true}
              lookupHandler={props.patternTypeLookupHandler}
              enterKeyEventHandler={typeEnterKeyEvent}
              autoCompleteListData={props.typePageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteTypeList}
              showAutoCompleteList={props.showAutoCompleteTypeList}
              disabled={props.isDisableFields}
            ></InputTextbox>
          </Col>
          <Col sm="1">
            <FormLabel>Content</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              onChange={onMakeTypeCodeChange}
              name="makeTypeCode"
              value={criteria.makeTypeCode}
              lookupRequired={true}
              lookupHandler={props.makeTypeLookupHandler}
              enterKeyEventHandler={makeTypeEnterKeyEvent}
              autoCompleteListData={props.makeTypePageListForAutoCompleteList}
              enableAutoCompleteTextBox={true}
              displayAutoCompleteList={displayAutoCompleteMakeTypeList}
              showAutoCompleteList={props.showAutoCompleteMakeTypeList}
              disabled={props.isDisableFields}
            ></InputTextbox>
          </Col>
        </Row>
      )}
    </div>
  );
}
function FabricStatisticsInquiry(props) {
  return (
    <div id="moduleContainer" class="module_container">
      <div id="app_container"></div>
      <FabricStatistics {...props} name="" /> <br />
    </div>
  );
}

export default FabricStatisticsInquiry;
